// This file is automatically generated. Do not edit it directly.
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";

const SUPABASE_URL = "https://yfbxhnsgbyxhglcafyhl.supabase.co";
const SUPABASE_PUBLISHABLE_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlmYnhobnNnYnl4aGdsY2FmeWhsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQ5MDM2MjgsImV4cCI6MjA3MDQ3OTYyOH0.SFO5FRhzotblAX0u0sl2CTZpkgyCzv8_DTwNab17R7c";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY
);
